import { appSettings } from '../AppSettings';
import { BaseGet } from './BaseData';
import { User } from './PermissionData';
import { TransitionDto } from './SampleTrackingTransitionData';

export type AuditChangeType = 'Create' | 'Change' | 'Delete';
export type AuditAction = 'Create' | 'Undo' | 'Tagging';
export type AuditType = 'Order' | 'Check By';

// This type is essentially the TransitionDto, with relevant details
// We want anything that is provided in this payload, except that of the TransitionDto itself, since those
// fields are captured elsewhere
export type AuditTransitionData = { [K in keyof TransitionDto]: never } & { [key: string]: unknown };

export const FromTransitionDto = (dto?: TransitionDto | undefined): AuditTransitionData | undefined => {
  if (dto === undefined) {
    return undefined;
  }

  const {
    transitionId,
    transition,
    transitionEnumId,
    researchProjectId,
    configuredTransitionId,
    orderedAt,
    createdAt,
    // Exclude the discriminator type parameter
    $transitionDetailsDtoType: _,
    ...rest
  } = dto || {
    researchProjectId: undefined,
    transitionId: undefined,
    transitionEnumId: undefined,
    transition: undefined,
    createdAt: undefined,
    orderedAt: undefined,
    configuredTransitionId: undefined,
    $transitionDetailsDtoType: undefined,
  };

  return { ...rest } as AuditTransitionData;
};

export interface AuditSampleTracking {
  auditSampleTrackingId: string;
  user: User;
  transition?: TransitionDto | undefined;
  action?: string | undefined;
  type?: string | undefined;
  transitionSamples: AuditTransitionSample[];
  createdAt?: Date | undefined;
}

export interface AuditTransitionSample {
  transitionSampleId: string;
  transitionSampleIdentifier?: string | undefined;
  sampleId: string;
  patientId: string;
  patientDeidentity: string;
  createdAt?: Date | undefined;
  parentTransitionSampleId?: string | undefined;
  parentAuditTransitionSample?: AuditTransitionSample | undefined;
  transitionSampleChangeData?: AuditTransitionSampleData | undefined;
}

export interface AuditTransitionSampleData {
  auditTransitionSampleChangeId: string;
  sampleIdentifier?: string | undefined;
  labAssignedSampleId?: string | undefined;
  checkByStatus?: string | undefined;
  checkByFailedReason?: string | undefined;
  qcStatus?: string | undefined;
  containerIdentifier?: string | undefined;
  containerSamplePosition?: string | undefined;
  containerType?: string | undefined;
  r1FastQLocation?: string | undefined;
  r2FastQLocation?: string | undefined;
  auditChangeType: string;
  createdAt?: Date | undefined;
}

export async function GetAuditsForResearchProject(
  researchProjectId: string,
  accessToken?: string | undefined,
  transitionType?: string | undefined
): Promise<ReadonlyArray<AuditSampleTracking>> {
  return await BaseGet(
    `${appSettings.api.endpoint}/api/v2/SampleTrackingAudits/ResearchProject/${researchProjectId}${
      transitionType ? `?transitionType=${transitionType}` : ''
    }`,
    accessToken
  );
}
